import { picoapp } from "picoapp";

import button from "./components/button";
import scrollAnimator from "./components/scroll-animator";

const components = {
  button,
  "scroll-animator": scrollAnimator,
};

const state = {
  isOpen: false,
};

export default picoapp(components, state);

console.log("Hello World!");
